/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import {
  WalletListResponse,
  WalletModal,
  WalletWithAmountResponse,
  BaseCurrencyRequest,
  WalletTotalBalanceResponse,
} from "@/shared/repository/modules/wallet/repo";
import { WalletModalFactory } from "@/shared/repository/modules/wallet/factory";
import { $projectServices } from "@/shared/repository/instances/project-services";
import { WalletFilterType } from "@/shared/repository/modules/wallet/enums";
import { AdminCurrencyType } from "@/shared/repository/modules/admin/currency/enums";

enum WalletMutation {
  UPDATE_MODAL = "UPDATE_MODAL",
  UPDATE_LIST = "UPDATE_LIST",
  UPDATE_WITH_AMOUNT = "UPDATE_WITH_AMOUNT",
  UPDATE_BALANCE = "UPDATE_BALANCE",
}

interface State {
  modal?: WalletModal;
  list?: WalletListResponse[];
  withAmount?: WalletWithAmountResponse[];
  balance?: WalletTotalBalanceResponse;
}

@Module({
  namespaced: true,
  stateFactory: true,
  name: "wallet",
})
export default class WalletModuleState extends VuexModule<State> {
  modal: WalletModal = WalletModalFactory();
  list: WalletListResponse[] = [];
  withAmount: WalletWithAmountResponse[] = [];
  balance: WalletTotalBalanceResponse = {
    fiat: { USD: 0 },
    crypto: { USDT: 0 },
    fiatCurrencys: ["USD"],
    cryptoCurrencys: ["USDT"],
  };

  @Mutation
  [WalletMutation.UPDATE_MODAL](modal: WalletModal): void {
    this.modal = modal;
  }

  @Mutation
  [WalletMutation.UPDATE_LIST](list: WalletListResponse[]): void {
    this.list = list;
  }

  @Mutation
  [WalletMutation.UPDATE_BALANCE](balance: WalletTotalBalanceResponse): void {
    this.balance = balance;
  }

  @Mutation
  [WalletMutation.UPDATE_WITH_AMOUNT](
    withAmount: WalletWithAmountResponse[]
  ): void {
    this.withAmount = withAmount;
  }

  @Action
  async wallet(baseCurrencys: BaseCurrencyRequest): Promise<void> {
    try {
      // Сначала пытаемся получить баланс
      let balance;
      try {
        balance = await $projectServices.walletRepository.totalBalance(
          baseCurrencys
        );
      } catch (balanceError) {
        // Загружаем только список кошелька
        const list = await $projectServices.walletRepository.list(
          WalletFilterType.all,
          $projectServices.userRepo.userInfo.id
        );

        // Пытаемся загрузить requisites отдельно
        try {
          const requisites =
            await $projectServices.adminCommissionRepository.requisitesList();

          this.UPDATE_LIST(
            list.filter((item) => {
              if (item.frozen || item.currency?.frozen) return false;

              if (item.type === AdminCurrencyType.crypto) return item;
              return requisites.find(
                (requisite) => requisite.currency.id === item.currency_id
              );
            })
          );
        } catch (requisitesError) {
          this.UPDATE_LIST(list.filter((item) => !item.frozen && !item.currency?.frozen));
        }

        // Проверяем разные форматы ошибки
        const errorMessage = (balanceError as { message: string })?.message;

        if (errorMessage && errorMessage.includes("wallet account")) {
          await $projectServices.walletRepository.create();
          balance = await $projectServices.walletRepository.totalBalance(
            baseCurrencys
          );
        } else {
          throw balanceError;
        }
      }

      // Получаем остальные данные
      const [list, withAmount, requisites] = await Promise.all([
        $projectServices.walletRepository.list(
          WalletFilterType.all,
          $projectServices.userRepo.userInfo.id
        ),
        $projectServices.walletRepository.withAmount(
          WalletFilterType.all,
          $projectServices.userRepo.userInfo.id
        ),
        $projectServices.adminCommissionRepository.requisitesList(),
      ]);

      this.UPDATE_BALANCE(balance);
      this.UPDATE_LIST(
        list.filter((item) => {
          // Фильтруем замороженные валюты для обычных пользователей
          if (item.frozen || item.currency?.frozen) return false;

          if (item.type === AdminCurrencyType.crypto) return item;

          return requisites.find(
            (requisite) => requisite.currency.id === item.currency_id
          );
        })
      );
      this.UPDATE_WITH_AMOUNT(
        withAmount.filter((item) => {
          if (item.currency_type === AdminCurrencyType.crypto) return item;

          return requisites.find(
            (requisite) => requisite.currency.id === item.currency_id
          );
        })
      );
    } catch (error) {
      console.log("Wallet error:", error);
      console.log("Error response:", (error as any)?.response);
      console.log("Error message:", (error as any)?.response?.data?.message);
    }
    // try {
    //   const [list, withAmount, requisites] = await Promise.all([
    //     $projectServices.walletRepository.list(WalletFilterType.all, userId),
    //     $projectServices.walletRepository.withAmount(
    //       WalletFilterType.all,
    //       userId
    //     ),
    //     $projectServices.adminCommissionRepository.requisitesList(),
    //   ]);

    //   this.UPDATE_LIST(
    //     list.filter((item) => {
    //       if (item.type === AdminCurrencyType.crypto) return item;

    //       return requisites.find(
    //         (requisite) => requisite.currency.id === item.currency_id
    //       );
    //     })
    //   );
    //   this.UPDATE_WITH_AMOUNT(
    //     withAmount.filter((item) => {
    //       if (item.currency_type === AdminCurrencyType.crypto) return item;

    //       return requisites.find(
    //         (requisite) => requisite.currency.id === item.currency_id
    //       );
    //     })
    //   );
    // } catch (error) {
    //   console.log(error);
    // }
  }
}
